import { jsx as o } from "react/jsx-runtime";
import t from "react";
import { c as u } from "./index.CWkFp9WS.js";
import { O as r, a as n, b as s, c as m, d, e as y } from "./ODSFlyoutMenu.DtVb_yUM.js";
import '../assets/ODSGlobalHeaderFlyoutMenu.css';const S = (e) => /* @__PURE__ */ o(
  r,
  {
    ...e,
    verticalOffset: -12,
    openOnHover: !0,
    className: "ODSGlobalHeaderFlyoutMenu-Content"
  }
);
S.displayName = "ODSGlobalHeaderFlyoutMenu";
const b = t.forwardRef(({ className: e, ...a }, l) => /* @__PURE__ */ o(
  n,
  {
    ref: l,
    className: u("ODSGlobalHeaderFlyoutMenu-Item", e),
    ...a
  }
));
b.displayName = "ODSGlobalHeaderFlyoutMenuItem";
const O = t.forwardRef(({ className: e, ...a }, l) => /* @__PURE__ */ o(
  s,
  {
    ref: l,
    className: u(
      "ODSGlobalHeaderFlyoutMenu-Item",
      "ODSGlobalHeaderFlyoutMenu-ItemLink",
      e
    ),
    ...a
  }
));
O.displayName = "ODSGlobalHeaderFlyoutMenuItemLink";
const D = t.forwardRef(({ className: e, ...a }, l) => /* @__PURE__ */ o(
  m,
  {
    ref: l,
    className: u("ODSGlobalHeaderFlyoutMenu-Item", e),
    ...a
  }
));
D.displayName = "ODSGlobalHeaderFlyoutMenuItemCheckbox";
const F = (e) => /* @__PURE__ */ o(
  d,
  {
    ...e,
    horizontalOffset: 4,
    className: "ODSGlobalHeaderFlyoutMenu-Content"
  }
);
F.displayName = "ODSGlobalHeaderFlyoutMenuSub";
const M = t.forwardRef(({ className: e, ...a }, l) => /* @__PURE__ */ o(
  y,
  {
    ref: l,
    className: u("ODSGlobalHeaderFlyoutMenu-Item", e),
    ...a
  }
));
M.displayName = "ODSGlobalHeaderFlyoutMenuSubTrigger";
export {
  S as O,
  b as a,
  O as b,
  D as c,
  F as d,
  M as e
};
//# sourceMappingURL=ODSGlobalHeaderFlyoutMenu.BmmQ7wLh.js.map
